import React, { useState, useRef, useEffect, useMemo } from "react";
import MaterialReactTable from 'material-react-table';
import SideBar from "./sidebar/Sidebar";
import FormCetak from "./FormCetak";
import ReactToPrint from "react-to-print";
import Dialog from "./Dialog";
import axios from 'axios';
import {useNavigate, Link, resolvePath, useLocation} from "react-router-dom";
import { toast } from 'react-toastify';
import PacmanLoader from "react-spinners/PacmanLoader";
import jwt_decode from "jwt-decode";
import Button from 'react-bootstrap/Button';

const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const Pengajuan = () => {
 
  const location = useLocation();
  const month = ["January","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
  const navigate = useNavigate();
  const [pinjaman, setPinjaman] = useState([]);
  const [role, setRole] = useState("");
  const [token, setToken] = useState("");
  const [expire, setExpire] = useState(""); 
  const [loading, setLoading] = useState(true);
  const [cabang, setCabang] = useState("");


  useEffect(() => {
    refreshToken();
  },[]);

  useEffect(() => {
     
      if (cabang && role) {
        getDebitur();
      }
    
  }, [cabang, role]);

  const getDebitur = async () => {
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/dashboard/${cabang}/${role}`,{
      headers:{
          Authorization:`Bearer ${token}`
      }
  });
    setPinjaman(response.data);
    // console.log('DATA: ', role);
    setLoading(false)
}
  
const axiosJWT = axios.create();
axiosJWT.interceptors.request.use(async(config) => {
  const curretDate = new Date();
  if(expire * 1000 < curretDate.getTime()){
      const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
      config.headers.Authorization = `Bearer ${response.data.accessToken}`;
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setRole(decoded.role);
      // console.log("ini jwt: ",role);
      setExpire(decoded.exp);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const refreshToken = async() => {
try {
    const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
    setToken(response.data.accessToken);
    const decoded = jwt_decode(response.data.accessToken);
    // console.log("ini decode: ",decoded.namaLengkap);
    // setUsername(decoded.username);
    // setEmail(decoded.email);
    setRole(decoded.role);
    setCabang(decoded.cabang);
    setExpire(decoded.exp);

} catch (error) {
  if(error.response){
    toast.warning("Silahkan Login!");
    navigate("/login");
  }
}
}

const [dialog, setDialog] = useState({
  message:"",
  isLoading:false,
  namaDebitur:""
});

const [dialog2, setDialog2] = useState({
  message:"",
  isLoading:false,
});

const handleDialog = (message, isLoading, namaDebitur)=> {
  setDialog({
      message,
      isLoading,
      namaDebitur
  });
};

const handleDialog2 = (message, isLoading)=> {
  setDialog2({
      message,
      isLoading
  });
};

const idDebiturRef = useRef();

const handleDelete = (idNasabah,namaDebitur)=> {
  handleDialog("Yakin Ingin Hapus?",true,namaDebitur);
  idDebiturRef.current = idNasabah;
  
};

const areUSureDelete = (choose) => {
  if (choose) {
    deletedebitur(idDebiturRef.current);   
    handleDialog("", false);
  } else {
    handleDialog("", false);
  }
};

const handleDeleteAll = ()=> {
  handleDialog2("Yakin Ingin Hapus Semua Data?",true);
  
};

const areUSureDeleteAll = (choose) => {
  if (choose) {
    deleteDataAll();   
    handleDialog2("", false);
  } else {
    handleDialog2("", false);
  }
};

const deletedebitur = async (idDebitur) =>{
      setLoading(true);
  try {
      await axios.delete(`${process.env.REACT_APP_MASTER_URL}/delete/${idDebitur}`);
      getDebitur();
      setLoading(false);
      toast.warning('Data Berhasil Dihapus...');
  } catch (error) {
      setLoading(false);
      console.log(error);
      toast.warning(`Gagal, ${error}`);
      
  }
}

const deleteDataAll = async () =>{
      setLoading(true);
  try {
      await axios.delete(`${process.env.REACT_APP_MASTER_URL}/deletedataall`);
      getDebitur();
      setLoading(false);
      toast.warning('Semua Data Berhasil Dihapus...');
  } catch (error) {
      setLoading(false);
      console.log(error);
      toast.warning(`Gagal, ${error}`);
      
  }
}
const columns = useMemo(
  () => [
    // ...
        {
          accessorKey: "idBiodata",
          header: "Aksi",
          size: 4,
          muiTableHeadCellProps: { sx: { color: "blue" } },
          Cell: (props) => (
            <a>
              <div className="button-reacttable">
                                      <Link to={`detaildebitur/${props.row.original.idDebitur}`} style={{ textDecoration: "none" }} className="button is-small is-link">Detail</Link>
                                      <button onClick={() => handleDelete(props.row.original.idDebitur, props.row.original.namaLengkap)}  style={{ textDecoration: "none" }} className="button is-small is-danger mt-1">Delete</button>
                                  </div>
              
             
            </a>
          ),
        },
// ...

    {
      accessorKey: "namaLengkap",
      header: "Debitur",
    },
    {
      accessorKey: "nomorIdentitas",
      header: "NIK",
    },
    {
      accessorKey: "tanggalLahir",
      header: "Tanggal Lahir",
    },
    {
      accessorKey: "tempatLahir",
      header: "Tempat Lahir",
    },
    {
      accessorKey: "debitur.cabang",
      header: "Cabang",
    },
    {
      accessorKey: "createdAt",
      header: "Tanggal Buat",
      Cell: (props) => {
        const date = new Date(props.row.original.createdAt);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        return <span>{formattedDate}</span>;
      },
    },
  ],
  []
); 
  

  return (
    <div style={{ margin: 0, padding: 0 }}>
    {loading ?
      <div style={stylespinner}>
         <PacmanLoader
                    color={'#301E67'}
                    loading={loading}
                    size={30}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
        </div> 
        :
      <SideBar>
         <img src={`${process.env.REACT_APP_MASTER_URL2}/logonusamba.png`}  alt="Not Found" width={200} height={200}></img>
         <div style={{ marginBottom: '1em', marginTop: '1em', display: 'flex'}}>
        <Link to={'tambahdebitur'} style={{ textDecoration: "none"}} className="button is-link">Tambah</Link>
        <button onClick={() => handleDeleteAll()}  style={{ textDecoration: "none" }} className="button is-danger ml-5">Hapus Semua Data</button>       
       </div>
        <MaterialReactTable columns={columns} data={pinjaman} />
        
      </SideBar>
    }
    {dialog.isLoading && (
                  <Dialog
                  //Update
                  nameProduct={dialog.namaDebitur}
                  onDialog={areUSureDelete}
                  message={dialog.message}
                  />
                  )}
      {dialog2.isLoading && (
                  <Dialog
                  //Update
                  onDialog={areUSureDeleteAll}
                  message={dialog2.message}
                  />
                  )}
    </div>
    
  );
};

export default Pengajuan;
